import React, { useEffect, useRef, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Footer from '../../components/Footer';
import emailjs from 'emailjs-com';

gsap.registerPlugin(ScrollTrigger);

const ContactPage = React.forwardRef((props, ref) => {
  const formRef = useRef();
  const [formData, setFormData] = useState({
    to_name: '',
    from_name: '',
    message: ''
  });
  const [formErrors, setFormErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    gsap.fromTo('.section-contact-title', 
      { opacity: 0, y: -50 , display:'none'}, 
      { opacity: 1, y: 0, duration: 1, ease: 'power2.out',display:'block', 
        scrollTrigger: {
          trigger: '.section-contact-title',
          start: 'top 80%', 
          toggleActions: 'play none none none'
        }
      }
    );
    gsap.fromTo('.section-title-project', 
      { opacity: 0, y: -50 , display:'none'}, 
      { opacity: 1, y: 0, duration: 1, ease: 'power2.out',display:'block', 
        scrollTrigger: {
          trigger: '.section-title-project',
          start: 'top 80%', 
          toggleActions: 'play none none none'
        }
      }
    );


    gsap.fromTo('.content-heading', 
      { opacity: 0, x: -100 , display:'none'}, 
      { opacity: 1, x: 0, duration: 1.2, ease: 'power2.out',display:'block', 
        scrollTrigger: {
          trigger: '.content-heading',
          start: 'top 80%',
          toggleActions: 'play none none none'
        }
      }
    );

    gsap.fromTo('.content-text', 
      { opacity: 0, x: 100, display:'none' }, 
      { opacity: 1, x: 0, duration: 1.2, ease: 'power2.out',display:'block', 
        scrollTrigger: {
          trigger: '.content-text',
          start: 'top 80%',
          toggleActions: 'play none none none'
        }
      }
    );
    gsap.fromTo('.custom-button'
      , { opacity: 0, y: 50 },
      { opacity: 1, y: 0, duration: 1.2, stagger: 0.3, ease: 'power2.out',
        scrollTrigger: {
          trigger: '.custom-button',
          start: 'bottom 100%',
          toggleActions: 'play none none none'
        }
      }
    )

    gsap.fromTo('.form-group', 
      { opacity: 0, y: 50 }, 
      { opacity: 1, y: 0, duration: 1.2, stagger: 0.3, ease: 'power2.out', 
        scrollTrigger: {
          trigger: '.form-group',
          start: 'top 80%',
          toggleActions: 'play none none none'
        }
      }
    );
  }, []);

  const validate = (values) => {
    let errors = {};
    if (!values.to_name) {
      errors.to_name = "Name is required";
    }
    if (!values.from_name) {
      errors.from_name = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(values.from_name)) {
      errors.from_name = "Email is invalid";
    }
    if (!values.message) {
      errors.message = "Message is required";
    }
    return errors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validate(formData);
    setFormErrors(errors);
    if (Object.keys(errors).length === 0) {
      setIsSubmitting(true);

      emailjs.sendForm('service_9fgrnsi', 'template_7deg2yl', formRef.current, 'th9-MvV77fkjebmmr')
        .then((result) => {
          alert('Email inviata con successo!');
          setIsSubmitting(false);
        }, (error) => {
          alert('Errore nell\'invio dell\'email. Riprova.');
          setIsSubmitting(false);
        });
    }
  };

  return (
    <>
      <div ref={ref}  className="container-fluid text-center position-relative min-height-90-y pt-5 d-flex flex-column justify-content-center">
        <h1 className="section-contact-title ms-lg-5 ms-1 text-break">CONTACT</h1>
        <div className="row p-4 p-lg-5 mt-md-5 mt-lg-5 align-items-center justify-content-center">
          <div className="col-md-4 col-12 d-flex justify-content-center align-items-end pb-md-5 pb-3">
            <div className="flex-column p-lg-5 d-flex align-items-start justify-content-start ">
              <h2 className="fw-bolder fs-1 content-heading text-start">
                Let's get in touch!
              </h2>
              <p className="text-secondary text-start content-text">
                Feel free to contact me!
              </p>
              <p className="text-start content-text">
                I’m always available to discuss new opportunities, collaborations, and opportunities to grow as a developer.
              </p>
            </div>
          </div>
          <div className="col-md-4 col-12">
            <Form ref={formRef} onSubmit={handleSubmit}>
              <Form.Group className="mb-3 text-start form-group" controlId="formBasicEmail">
                <Form.Control 
                className={formErrors.to_name && 'border-danger'}
                  type="text" 
                  name="to_name" 
                  placeholder=" name*" 
                  value={formData.to_name}
                  onChange={handleChange}
                />
                {formErrors.to_name && <p className="text-danger">{formErrors.to_name}</p>}
              </Form.Group>
              <Form.Group className="mb-3 text-start form-group" controlId="formBasicEmail">
                <Form.Control 
                  className={formErrors.from_name  && 'border-danger'}
                  type="email" 
                  name='from_name' 
                  placeholder=" email*" 
                  value={formData.from_name}
                  onChange={handleChange}
                />
                {formErrors.from_name && <p className="text-danger">{formErrors.from_name}</p>}
              </Form.Group>
              <Form.Group className="mb-3 text-start form-group" controlId="formBasicPassword">
                <FloatingLabel controlId="floatingTextarea2" label="Message*">
                  <Form.Control
                    className={formErrors.message   && 'border-danger'}
                    name='message'
                    as="textarea"
                    placeholder="Leave a comment here"
                    style={{ height: '100px' }}
                    value={formData.message}
                    onChange={handleChange}
                  />
                </FloatingLabel>
                {formErrors.message && <p className="text-danger">{formErrors.message}</p>}
              </Form.Group>
              <div className="d-flex justify-content-end">
                <Button className="ms-auto custom-button form-submit bg-light rounded-5 px-4 fw-bold" disabled={isSubmitting} type="submit">
                  Submit
                </Button>
              </div>
            </Form>
          </div>
        </div>
      </div>
      <Footer/>
    </>
  );
});

export default ContactPage;